import { TAGS } from "../constants";
import { CreateMedicationStrength, MedicationStrength } from "../types";
import { api } from "./api";

export const medicationStrengthsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getStrengths: builder.query<MedicationStrength[], void>({
      query: () => ({
        method: "GET",
        url: `/api/medication-strengths`,
      }),
      providesTags: [
        TAGS.MEDICATION_STRENGTHS,
        TAGS.MEDICATION,
        TAGS.PRODUCT_MEDICATIONS,
      ],
    }),
    addMedicationStrengthsMedications: builder.mutation<
      void,
      { medication_id: number; strength_id: number }
    >({
      query: (body) => ({
        method: "POST",
        url: `/api/medication-strengths/add`,
        body,
      }),
      invalidatesTags: [
        TAGS.MEDICATION_STRENGTHS,
        TAGS.MEDICATION,
        TAGS.PRODUCT_MEDICATIONS,
      ],
    }),
    createMedicationStrength: builder.mutation<
      MedicationStrength,
      { medicationId: number; body: CreateMedicationStrength }
    >({
      query: ({ medicationId, body }) => ({
        method: "POST",
        url: `/api/medication-strengths/medication/${medicationId}`,
        body,
      }),
      invalidatesTags: [
        TAGS.MEDICATION_STRENGTHS,
        TAGS.MEDICATION,
        TAGS.PRODUCT_MEDICATIONS,
      ],
    }),
  }),
});

export const {
  useGetStrengthsQuery,
  useAddMedicationStrengthsMedicationsMutation,
  useCreateMedicationStrengthMutation,
} = medicationStrengthsApi;
